import PropTypes from "prop-types";
import { Box, Button, Card, IconButton, Typography } from "@mui/material";
import { format } from "date-fns";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SimCardDownloadOutlinedIcon from "@mui/icons-material/SimCardDownloadOutlined";
import { BillUploadDetail, BooleanInput } from "../../../components";
import { useModal } from "../../../context";
import { formatCurrency } from "../../../utils";
import { arrayBill } from "../../../utils/helpers";
import DownloadCard from "./DownloadCard";

function IncomeCard({
  incomeData,
  color,
  isSelectable,
  onCardCheckedChange,
  dragged,
}) {
  const { setModalOpen: setDetailModalOpen } = useModal();
  const { setModalOpen: setDownloadModalOpen } = useModal();
  return (
    <Card
      key={incomeData?.Clave?._text}
      color={color}
      sx={{
        display: "flex",
        backgroundColor: incomeData.dragged ? "#153655" : "inherit",
        flexDirection: "column",
        alignItems: "start",
        minHeight: 338,
        height: "100%",
        gap: "0.6rem",
        padding: "1rem",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: isSelectable ? "space-between" : "end",
        }}
      >
        {isSelectable && (
          <BooleanInput
            name={incomeData?.Clave?._text}
            value={incomeData?.selected}
            onChange={(name, value) => onCardCheckedChange?.(name, value || 0)}
          />
        )}
        <IconButton
          onClick={() =>
            setDetailModalOpen(
              true,
              <BillUploadDetail electronicDocument={arrayBill(incomeData)} />,
              "",
              false,
              true,
            )
          }
        >
          <VisibilityOutlinedIcon />
        </IconButton>
      </Box>
      <Box
        align="start"
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "0.1rem",
          overflowX: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: { xs: "200px", sm: "250px" },
          height: "26px",
        }}
      >
        <Typography fontWeight={600} typography="modeColor" variant="subtitle1">
          Receptor:
        </Typography>
        <Typography
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          typography="modeColor"
          variant="subtitle1"
        >
          {incomeData?.Receptor?.NombreComercial?._text ||
            incomeData?.Receptor?.Nombre?._text ||
            "Sin receptor"}
        </Typography>
      </Box>
      <Typography align="start" typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold"> Cédula: </span>{" "}
        {incomeData?.Receptor?.Identificacion?.Numero?._text || "---"}
      </Typography>
      <Typography typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold"> Moneda: </span>{" "}
        {incomeData?.ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda?._text}
      </Typography>
      <Typography typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold"> Total: </span>{" "}
        {formatCurrency(
          parseFloat(incomeData.ResumenFactura?.TotalVentaNeta?._text, 10),
          incomeData?.ResumenFactura?.CodigoTipoMoneda?.CodigoMoneda?._text,
        )}
      </Typography>
      <Typography typography="modeColor" variant="subtitle1">
        <span className="has-text-weight-bold"> Fecha: </span>{" "}
        {format(new Date(incomeData?.FechaEmision?._text), "dd/MM/yyyy")}
      </Typography>
      <Typography typography="modeColor" variant="subtitle1">
        {format(new Date(incomeData?.FechaEmision?._text), "hh:mm a")}
      </Typography>
      {incomeData.id && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={e => {
              e.preventDefault();
              window.open(
                `/CreditDebitNote/${incomeData.id}/CreditNotes`,
                "_blank",
              );
            }}
          >
            Crear nota de crédito
          </Button>

          <IconButton
            size="large"
            onClick={() =>
              setDownloadModalOpen(
                true,
                <DownloadCard
                  incomeID={incomeData?.Clave._text}
                  setModalOpen={setDownloadModalOpen}
                />,
                "",
                false,
                true,
              )
            }
          >
            <SimCardDownloadOutlinedIcon fontSize="large" />
          </IconButton>
        </Box>
      )}
    </Card>
  );
}

export default IncomeCard;

IncomeCard.propTypes = {
  incomeData: PropTypes.object,
  color: PropTypes.string,
  isSelectable: PropTypes.bool,
  onCardCheckedChange: PropTypes.func,
  dragged: PropTypes.bool,
};
IncomeCard.defaultProps = {
  incomeData: undefined,
  color: "primary",
  isSelectable: false,
  onCardCheckedChange: undefined,
  dragged: false,
};
